import {
  AlignItems,
  Box,
  JustifyContent,
  P,
  Space,
  TypePreset,
  Color,
  ResponsiveValue,
  ColorProp,
  BoxProps,
  Glyph,
  Icon,
} from "@gocardless/flux-react";

interface BannerProps extends BoxProps {
  children?: React.ReactNode;
  bg?: ResponsiveValue<ColorProp>;
  dataTestId?: string;
}

const AlertBanner: React.FC<BannerProps> = ({
  dataTestId,
  ...props
}: BannerProps) => (
  <Box
    data-testid={dataTestId}
    layout="flex"
    borderRadius={1}
    bg={Color.Sunrise_100}
    flexWrap="wrap"
    alignItems={AlignItems.Center}
    justifyContent={JustifyContent.FlexStart}
    minHeight={64}
    width="100%"
    gutterH={1.5}
    gutterV={1}
    {...props}
  >
    <Box layout="flex" gutterH={0.5} gutterV={0.5}>
      <Icon name={Glyph.Warning} />
    </Box>
    <Space h={0.25} layout="inline" />
    <Box spaceAfter={1}>
      <P preset={TypePreset.Body_01}>{props.children}</P>
    </Box>
  </Box>
);

export default AlertBanner;
